import {
    Component,
    HostBinding,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fe-banner-landing-title',
    templateUrl: './banner-landing-title.component.html',
    styleUrls: ['./banner-landing-title.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class BannerLandingTitleComponent {
    @Input() title?: string | null;
    @Input() imageSrc!: string;
    @Input() subtitle?: string | null;

    @HostBinding('class.container-card-landing-title')
    private containerBannerLadingTitleClass = true;

    @HostBinding('class.position-relative') private positionRelativeClass =
        true;

    @HostBinding('class.d-block') private dBlockClass = true;
}
